import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 30000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
Utils.updateAuthorization()


export default {
    getStrings(callback) {
        axios.get(axios.defaults.ptApiUrl + 'translations?lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getRegisterConfig(callback) {
        axios.get(axios.defaults.ptApiUrl + 'register_config?db_id=' + window.ptId + '&check_enable=1&website=1' + (window.configType ? ('&type=' + window.configType) : '') + (window.apiDev ? '&dev=1' : ''), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    createOrderVW(data, callback) {
        axios.post(axios.defaults.ptApiUrl + 'vw/order/create?pt_id=' + window.ptId + '&website=1&lng=' + window.language, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        })
        .then((response) => {
            Utils.processResponse(response, callback)
        })
        .catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
